export default "__VITE_ASSET__MS4VO_sg__"